/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Hub_Meta_CompanyInputs */

const cs_social_hub_meta_company = /** @type {(inputs: Social_Hub_Meta_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firemní Meta`)
};

const en_social_hub_meta_company = /** @type {(inputs: Social_Hub_Meta_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company Meta`)
};

/**
* | output |
* | --- |
* | "Company Meta" |
*
* @param {Social_Hub_Meta_CompanyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_hub_meta_company = /** @type {((inputs?: Social_Hub_Meta_CompanyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Hub_Meta_CompanyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_hub_meta_company(inputs)
	return cs_social_hub_meta_company(inputs)
});